import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import { RemindersView } from "@/components/aicheck/RemindersView";
import type { AICheckRunResult } from "@/types/aicheck";

interface RemindersTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
  onReturnToSummary: (findingIndex: number) => void;
  onProjectDataReferenceClick: (source: string) => void;
}

/** 「Reminders」タブ本体。tabpanel ラッパ + RemindersView。 */
export function RemindersTab({
  result,
  activeTab,
  onReturnToSummary,
  onProjectDataReferenceClick,
}: RemindersTabProps) {
  return (
    <div
      id="results-panel-reminders"
      role="tabpanel"
      aria-labelledby="results-tab-reminders"
      hidden={activeTab !== "reminders"}
    >
      <RemindersView
        result={result}
        onReturnToSummary={onReturnToSummary}
        onProjectDataReferenceClick={onProjectDataReferenceClick}
      />
    </div>
  );
}
